import type { WsDepotCardFilter } from "../../../../../../api/wsDepotCards";
import { defineFilterConfig, filterFieldAdapters } from "@src/components/business-form";

/** Значения filter-формы списка цеховой номенклатуры. */
export interface WsDepotCardsFilterFormValues {
    num: string;
    divisionCode: number | null;
    stockobjSign: string;
    stockobjName: string;
    stockobjNomNum: string;
}

export const wsDepotCardsFilterFormConfig = defineFilterConfig<WsDepotCardsFilterFormValues, WsDepotCardFilter>({
    fields: {
        num: {
            type: "string",
            label: "Номер карточки",
            map: filterFieldAdapters.ompSearchString("Num"),
        },
        divisionCode: {
            type: "number",
            nullable: true,
            label: "Подразделение",
            map: filterFieldAdapters.entityCode("DivisionCode"),
        },
        stockobjSign: {
            type: "string",
            label: "Обозначение ТМЦ",
            map: filterFieldAdapters.ompSearchString("StockobjSign"),
        },
        stockobjName: {
            type: "string",
            label: "Наименование ТМЦ",
            map: filterFieldAdapters.ompSearchString("StockobjName"),
        },
        stockobjNomNum: {
            type: "string",
            label: "Заводской код ТМЦ",
            map: filterFieldAdapters.ompSearchString("StockobjNomNum"),
        },
    },
});
